'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MasonryLayout = require('./components/MasonryLayout');

var _MasonryLayout2 = _interopRequireDefault(_MasonryLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MasonryLayout2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-masonry-layout/lib/index.js
// module id = ./node_modules/react-masonry-layout/lib/index.js
// module chunks = vendor